import { InvoiceTypes } from '../../../Interfaces/Draft/DraftInterface'

export const getDeductionFromInvoiceType = (invoiceType: number) => {
  if (![InvoiceTypes.SALES_HOUSEHOLD_SE_ROT, InvoiceTypes.SALES_HOUSEHOLD_SE_RUT].includes(invoiceType)) {
    return { visible: false, value: 0 }
  }
  return { visible: true, value: invoiceType === InvoiceTypes.SALES_HOUSEHOLD_SE_ROT ? 30 : 50 }
}
